export class SuggestedCategory1 {
  constructor(
    public category1: string,
    public email: string,
    public description = '',
    public id = '',
    public uid = ''
  ) {}
}
